import carcare from "../../node_modules/common/src/components/pay/carcare";
import carInsur from "../../node_modules/common/src/components/pay/carInsur";
import carOil from "../../node_modules/common/src/components/pay/carOil";
import carViolation from "../../node_modules/common/src/components/pay/carViolation";
import otherPay from "../../node_modules/common/src/components/pay/otherPay";
import repair from "../../node_modules/common/src/components/pay/repair";
var data = [
  {
    path: "/carcare",
    component: carcare
  },
  {
    path: "/carInsur",
    component: carInsur
  },
  {
    path: "/carOil",
    component: carOil
  }, {
    path: "/carViolation",
    component: carViolation
  }, {
    path: "/otherPay",
    component: otherPay
  }, {
    path: "/repair",
    component: repair
  },
  /*   {
    path: "/rule/gaofeng",
    component: () => import("@/components/rule/ruleGaofeng")
  } */
];
export default data;



// WEBPACK FOOTER //
// ./src/router/pay.js